module.exports = __webpack_public_path__ + "img/circle-4-light.daf0152b.svg";